import {
  SAVE_TEMPLATE,
  FETCH_TEMPLATES,
  DELETE_TEMPLATE,
} from "../constants/actionTypes";
import * as api from "../api/index.js";
import { decryptData } from "../Components/utils/EncriptionStore";

const user = (() => {
  const encryptedData = localStorage.getItem("profile");
  return encryptedData ? decryptData(encryptedData) : null;
})();
export const saveTemplate = (formData) => async (dispatch) => {
  try {
    const response = await api.saveTemplate(formData);
    dispatch({
      type: SAVE_TEMPLATE,
      payload: response.data,
    });
  } catch (error) {
    console.error("SAVE_TEMPLATE error", error);
  }
};

export const fetchTemplates = () => async (dispatch) => {
  try {
    const response = await api.fetchTemplates({
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    });
    console.log("FETCH_TEMPLATES response", response);
    dispatch({
      type: FETCH_TEMPLATES,
      payload: response.data,
    });
  } catch (error) {
    console.error("FETCH_TEMPLATES error", error);
  }
};

export const deleteTemplate = (formData) => async (dispatch) => {
  try {
    const response = await api.deleteTemplate(formData);
    dispatch({
      type: DELETE_TEMPLATE,
      payload: {
        ...response.data,
        name: formData.name, // include the deleted template name
      },
    });
  } catch (error) {
    console.error("DELETE_TEMPLATE error", error);
  }
};
